import { render, staticRenderFns } from "./AdminEditAnnouncementModal.vue?vue&type=template&id=060fac6d"
import script from "./AdminEditAnnouncementModal.vue?vue&type=script&lang=js"
export * from "./AdminEditAnnouncementModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports